import { render, staticRenderFns } from "./IrrRequestRootComponent.vue?vue&type=template&id=79f1ea0c"
import script from "./IrrRequestRootComponent.vue?vue&type=script&lang=js"
export * from "./IrrRequestRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports